export enum OrderStatusEnum {
  PROCESSING = 'processing',
  PENDING_PAYMENT = 'pending_payment',
  ON_HOLD = 'holded',
  OPEN = 'open',
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  SHIPPED = 'shipped',
  COMPLETE = 'complete',
  CANCELED = 'canceled',
}
